import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';

const styles = {
    checkbox: {
        labelStyle: { fontSize: '14px', color: '#333' },
    },
};

class Warehouses extends React.Component {
    render() {
        return (
            <Fragment>
                <div className="warehouses">
                    <div className="row divided">
                        <div className="col-xs-3" style={styles.checkbox.labelStyle}>
                            WAREHOUSES
                        </div>
                    </div>
                    <div className="row divided">
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.timber"
                                component={Checkbox}
                                label="Timber"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.grain"
                                component={Checkbox}
                                label="Grain"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.lpg"
                                component={Checkbox}
                                label="LPG"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.chemicals"
                                component={Checkbox}
                                label="Chemicals"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                    </div>

                    <div className="row divided">
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.dryBulk"
                                component={Checkbox}
                                label="Dry bulk (ore, coal, etc)"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.liquid"
                                component={Checkbox}
                                label="Liquid"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.general"
                                component={Checkbox}
                                label="General cargo"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                        <div className="col-xs-3">
                            <Field
                                name="warehouses.reefer"
                                component={Checkbox}
                                label="Reefer cargo"
                                labelStyle={styles.checkbox.labelStyle}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Warehouses.propTypes = {

};

Warehouses.defaultProps = {

};

export default Warehouses;



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/Warehouses.jsx